import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardError } from '@monorepo/nova-ui';
import { useDashboard } from '../../../contexts';
import { useAccountStatisticsData } from '../../../hooks';
import { AccountStatisticsLoading } from './account-statistics-loading';
import {
  AccountStatisticsLayout,
  CardsSection,
  StatisticsGrid,
} from './components';

export const AccountStatistics: FC = () => {
  const { account } = useDashboard();

  const { t } = useTranslation('accountStatistics');

  const {
    data: accountStats,
    isLoading,
    isError,
    refetch,
  } = useAccountStatisticsData(
    account?.tsAccountId || '',
    account || undefined,
  );

  if (!account) {
    return null;
  }

  if (isLoading) {
    return <AccountStatisticsLoading />;
  }

  if (isError || !accountStats) {
    return (
      <DashboardError
        title={t('error.title')}
        message={t('error.message')}
        onRetry={() => refetch()}
      />
    );
  }

  return (
    <AccountStatisticsLayout>
      <StatisticsGrid />
      <CardsSection />
    </AccountStatisticsLayout>
  );
};
